import { Component, OnDestroy, OnInit } from '@angular/core';
import * as globals from "../../globals";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { showAnimation } from 'src/animations';
import { SessionService } from 'src/app/lib/shared/services/session.service';
import { delay, take } from 'rxjs/operators';
import { RootService } from 'src/app/services/root.service';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from 'src/app/lib/user/services/user.service';
import { MatDialog } from '@angular/material/dialog';
import { ResetPasswordDialogComponent } from 'src/app/lib/user/components/dialog/reset-password-dialog/reset-password-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  animations: [showAnimation]
})
export class LoginComponent implements OnDestroy, OnInit {

  /**
   * the FormGroup ist required for the validation
   */
  formGroup: FormGroup;

  loginState: number = null;

  wrongCredentials: boolean = false;
  lockedOut: boolean = false;

  lockedOutEnd: Date = new Date();

  private _subscriptions: Subscription[] = [];

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _sessionService: SessionService,
    private _rootService: RootService,
    private _dialog: MatDialog,
    private _snackBar: MatSnackBar
  ) { }
  /**
   * the method clears the current values
   */
  clear() {
    this.formGroup.controls.password.setValue(null);
    this.formGroup.controls.username.setValue(null);
  }
  /**
   * the method loggs the current user in
   */
  login = () => this._sessionService.login(this.formGroup.value.username, this.formGroup.value.password).subscribe({
    next: () => this.redirect(),
    error: (error: HttpErrorResponse) => {
      switch (error.status) {
        case 400:
          this.wrongCredentials = true;
          break;
        case 409:
          this.lockedOut = true;
          break;
      }
    }
  });

  navigateToCustomerClient() {
    location.href = globals.customerClientURI;
  }
  /**
   * the method is called on component disposition
   */
  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit() {
    this._rootService.hideNavbar();
    this.formGroup = new FormGroup({
      username: new FormControl(null, [
        Validators.required
      ]),
      password: new FormControl(null, [
        Validators.required
      ])
    });
    this._sessionService.tryLogin().pipe(take(1)).subscribe({ next: (value) => this.redirect() });
  }

  redirect = () => {
    var redirect: string = this._route.snapshot.queryParams['redirect'];
    redirect ? this._router.navigateByUrl(redirect) : this._router.navigate(['home']);
  }

  startPasswordReset(){
    this._dialog.open(ResetPasswordDialogComponent, {
      panelClass: 'no-padding-dialog-container',
    }).afterClosed().subscribe((result) => {
      if(result) this._sessionService.startPasswordReset(result.userName, result.email).subscribe({
        next: () => this._snackBar.open('Sie finden die E-Mail zum Zurücksetzen Ihres Passworts in ihrem Posteingang', 'Ok', {
          duration: 2000
        }),
        error: () => this._snackBar.open('Das hat nicht geklappt', 'Ok', {
          duration: 2000
        })
      });
    });
  }
  /**
   * the method checks whether at least one form value is setted
   */
  valuesSetted(): boolean {
    if (
      (this.formGroup.value.username != null && this.formGroup.value.username != "") ||
      (this.formGroup.value.password != null && this.formGroup.value.password != "")
    ) return true;
    return false;
  }

}
